import type { PostCampaignStatus } from '@/services/ws-post/src/main/resources/rest-api';

import type { ParamsValidator } from 'src/components/RouteParamsValidator.tsx';
import { POST_CAMPAIGN_STATUSES } from 'src/constants.ts';

export const validatePostCampaignStatus: ParamsValidator<{ status: PostCampaignStatus }> = ({ status }) =>
  POST_CAMPAIGN_STATUSES.includes(status);
